
/**
 * Generate an absolute polygon apps url based on environment.
 * @param path Relative path to be used with calculated domain
 * @param legacy Use the old /apply/ urls
 * @param root If using legacy urls, just append path to the bare domain without /apply/
 * @returns 
 */
export function absPolygonUrl(path: string, legacy: boolean = false, root: boolean = false) {
  if (path.startsWith('http')) return path;
  if (path.length === 0 || path[0] !== '/') path = `/${path}`;

  // TODO: have less explicit parsing rules - it should really all come from env
  const domain = process.env.REACT_APP_HOST?.replace('polygonapp', 'polygongroup');
  if (legacy) {
    return `https://${domain?.replace('apply.', '')}${root ? '' : '/apply'}${path}`;
  }
  return `https://${domain}${path}`;
}
